export default __webpack_public_path__ + "static/media/equicode-site.2d98ec26.mp4";